import { SchemaInterface, ConsentOptionsInterface } from '@app/shared/types/schema-interface';

export class SchemaConsents {
  constructor(private schema: SchemaInterface) {}

  public availableConsentsKeys(): string[] {
    return this.schema.consents_order;
  }

  public consentOptions(consentKey: string): ConsentOptionsInterface {
    return this.schema.consents[consentKey];
  }

  public isRequired(consentKey: string): boolean {
    const consentOptions = this.consentOptions(consentKey);
    if (!consentOptions) { return true; }
    if (consentOptions.required == null) { return true; }

    return consentOptions.required;
  }

  public showInProfile(consentKey: string): boolean {
    const consentOptions = this.consentOptions(consentKey);
    if (!consentOptions) { return true; }
    if (consentOptions.show_in_profile == null) { return true; }

    return consentOptions.show_in_profile;
  }

  public showAtRegistration(consentKey: string): boolean {
    const consentOptions = this.consentOptions(consentKey);
    if (!consentOptions) { return true; }
    if (consentOptions.show_at_registration == null) { return true; }

    return consentOptions.show_at_registration;
  }
}
